import { Button, Flex, Modal, ModalCloseResult, Typography } from '@alpine-iq/ui-library';
import React from 'react';

type AlertModalProps = {
	open: boolean;
	onCancel?: () => void;
	// Returning false will prevent the modal from closing
	onConfirm: () => false | Promise<false> | any | void;
	onClose: (result?: ModalCloseResult) => void;

	confirmButtonLabel?: React.ReactNode;
	cancelButtonLabel?: React.ReactNode;

	title?: React.ReactNode;
	description?: React.ReactNode;

	modalProps?: React.ComponentProps<typeof Modal>;

	hideConfirmButton?: boolean;
	fakeDelay?: number;

	children?: React.ReactNode;
};

export default function AlertModal(props: AlertModalProps) {
	const [loading, setLoading] = React.useState<boolean>(false);

	async function handleConfirm() {
		let result = true;
		if (props.onConfirm) {
			setLoading(true);
			const startTime = performance.now();
			result = (await props.onConfirm?.()) ?? true;
			const endTime = performance.now();
			const timeElapsed = endTime - startTime;
			const fakeDelay = props.fakeDelay ?? 300;
			if (timeElapsed < fakeDelay) {
				await new Promise((resolve) => setTimeout(resolve, fakeDelay - timeElapsed));
			}
			setLoading(false);
		}
		if (result !== false) handleClose();
	}

	function handleClose(result?: ModalCloseResult) {
		props.onClose?.(result);
	}

	function handleCancel() {
		props.onCancel?.();
		handleClose();
	}

	return (
		<>
			<Modal
				open={props.open}
				onClose={handleClose}
				{...props.modalProps}
			>
				<Flex
					column
					gap="24"
				>
					<Typography variant="h2">{props.title}</Typography>
					{props.children || <Typography variant="body">{props.description}</Typography>}
					<Flex justify="flex-end">
						<Button
							size="medium"
							onClick={handleCancel}
						>
							{props.cancelButtonLabel ?? 'Cancel'}
						</Button>
						{!props.hideConfirmButton && (
							<>
								<Button
									size="medium"
									variant="primary"
									onClick={() => handleConfirm()}
									loading={loading}
								>
									{props.confirmButtonLabel ?? 'Confirm'}
								</Button>
							</>
						)}
					</Flex>
				</Flex>
			</Modal>
		</>
	);
}
